(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hundriket-catalog"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hundriket-catalog')) {
    customElements.define('hundriket-catalog', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-ready')) return;
        this.setAttribute('data-ready', '');
        const toggle = this.querySelector('.hr-catalog__mobile-toggle');
        toggle.addEventListener('click', () => {
          const open = toggle.getAttribute('aria-expanded') !== 'true';
          toggle.setAttribute('aria-expanded', String(open));
          this.dataset.menuOpen = String(open);
          toggle.querySelector('.hr-catalog__toggle-symbol').textContent = open ? '−' : '+';
        });
        this.querySelector('[name="sort_by"]').addEventListener('change', (event) => {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', event.target.value);
          url.searchParams.delete('page');
          window.location.assign(url.toString());
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
